import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ShareableLinkLockScreen from '../ShareableLinkLockScreen';
import WaitingImage from 'assets/images/members.webp';

import './ShareableLinkNdaConnecting.styles.scss';

type ShareableLinkNdaConnectingProps = {
  className?: string;
};

const ShareableLinkNdaConnecting: React.FC<ShareableLinkNdaConnectingProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('shareable-link-nda-connecting', className);

  const { t } = useTranslation();

  return (
    <ShareableLinkLockScreen
      className={classes}
      image={WaitingImage}
      title={t('ndaPrepared')}
      description={t('ndaIsBeingAddedToDR')}
    />
  );
};

export default ShareableLinkNdaConnecting;
